import React from 'react'
import { Route, Routes } from "react-router-dom";
import AgentsPage from '../../pages/features/agents/AgentsPage';
import AgentDetailsPage from '../../pages/features/agents/AgentDetailsPage';
import UpdateAgentPage from '../../pages/features/agents/UpdateAgentPage';



export default function AgentNav() {
  return (
    <Routes>
      <Route path="/" element={<AgentsPage />} />
      <Route path="/details" element={<AgentDetailsPage />} />
      <Route path="/update" element={<UpdateAgentPage />} />

    </Routes>
  );
}
